import * as z from 'zod'

import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const legal_documents_email = () =>
  ({
    schema: z.object({ legalDocumentsEmailOptin: z.literal(true) }).passthrough(),
    stepContent: [
      {
        type: 'customComponent',
        name: 'LegalDocumentsEmail',
        inputs: [],
        outputs: ['legalDocumentsEmailOptin'],
        props: {},
      },
    ],
    subFlow: SubFlow.PaymentAndConfirmation,
    nextStep: 'confirmations',
    showOrderSummary: true,
  }) as const satisfies AnyStepConfiguration

export default legal_documents_email
